import api from './api';
import { ApiResponse, Summary } from '../models';

export interface SummaryGenerateRequest {
  consultation_id: number;
  prompt_id?: number;
  source_text?: string;
}

export interface FieldAutoFillRequest {
  template_id: number;
  source_text: string;
  consultation_id?: number;
  prompt_id?: number;  // 프롬프트 ID (미지정시 기본 프롬프트 사용)
}

export interface FieldAutoFillResponse {
  form_data: Record<string, string>;
  model_used: string;
  tokens_used?: number;
  prompt_id?: number;
  prompt_name?: string;
}

export const summaryService = {
  async generate(data: SummaryGenerateRequest): Promise<Summary> {
    const response = await api.post<ApiResponse<Summary>>('/summaries/generate/', data);
    return response.data.data;
  },

  async regenerate(id: number): Promise<Summary> {
    const response = await api.post<ApiResponse<Summary>>(`/summaries/${id}/regenerate/`);
    return response.data.data;
  },

  async getList(consultationId?: number): Promise<Summary[]> {
    const params = consultationId ? { consultation: consultationId } : {};
    const response = await api.get<ApiResponse<Summary[]>>('/summaries/', { params });
    return response.data.data;
  },

  async getById(id: number): Promise<Summary> {
    const response = await api.get<ApiResponse<Summary>>(`/summaries/${id}/`);
    return response.data.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/summaries/${id}/`);
  },

  // 필드 자동채우기 - STT 텍스트에서 템플릿 필드별 내용 추출
  async autoFill(data: FieldAutoFillRequest): Promise<FieldAutoFillResponse> {
    const response = await api.post<ApiResponse<FieldAutoFillResponse>>('/summaries/auto-fill/', data);
    return response.data.data;
  },
};
